import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import isObject from 'lodash/isObject'
import {
  changeMarketplaceListingAttr,
  submit,
  setMarketplaceListing,
  resetEditor,
} from '../actions/marketplace_listing_editor'
import { openModal, closeModal } from '../actions/modal'
import { fetchMarketplaceListingById } from '../actions/marketplace_listings'
import { fetchMarketplaceListingCategories } from '../actions/marketplace_listing_categories'
import {
	MODAL_CONFIRM,
	MARKETPLACE_LISTING_CONDITIONS,
	MARKETPLACE_LISTING_COLOR_OPTIONS,
	MARKETPLACE_LISTING_YEAR_OPTIONS,
	MODAL_LOCATION,
	POPOVER_MANAGED_BUSINESSES,
} from '../constants'
import { me, meBusinesses } from '../initial_state'
import ColumnIndicator from '../components/column_indicator'
import Button from '../components/button'
import Divider from '../components/divider'
import Input from '../components/input'
import Text from '../components/text'
import Select from '../components/select'
import Textarea from '../components/textarea'
import MarketplaceListingMediaUploadBlock from '../components/marketplace/marketplace_listing_media_upload_block'
import Avatar from '../components/avatar'
import DisplayName from '../components/display_name'
import Icon from '../components/icon'
import MarketplaceListingPreview from '../components/previews/marketplace_listing_preview'
import { fetchMarketplaceListingAvailableAttributes } from '../actions/marketplace_listing_search'
import Switch from '../components/switch'
import { openPopover } from '../actions/popover'
import Image from '../components/image'
import { parseQuerystring } from '../utils/querystring'
import { fetchManagedBusinesses } from '../actions/businesses'

const conditionsOptions = [{'title':'',value:''}]
for (const key in MARKETPLACE_LISTING_CONDITIONS) {
	// no "All"
	if (key != 0) {
		conditionsOptions.push(MARKETPLACE_LISTING_CONDITIONS[key])
	}
}

class MarketplaceListingCreate extends ImmutablePureComponent {

  static contextTypes = {
    router: PropTypes.object,
  }

  componentDidMount() {
		const { itemId, item, categories } = this.props

		if (!categories || categories.size === 0) {
			this.props.onFetchMarketplaceListingCategories()
		}
		if (Array.isArray(meBusinesses)) {
			this.props.onFetchManagedBusinesses()
		}

		this.props.onResetEditor()
		// this.handleOnResetLister()

    if (!item && !!itemId) {
      this.props.onFetchMarketplaceListing(itemId)
    } else if (itemId) {
      this.props.onSetMarketplaceListing(item)
			if (!!item) {
				if (!!item.get('business_id')) {
					this.handleOnChangeLister(item.get('business_id'))
				}
			}
    }

		try {
			const qp = parseQuerystring({ business_id: null })
			if (!!qp.business_id) this.handleOnChangeLister(qp.business_id)
		} catch (error) {
			console.log("error:",error)
		}
  }

	componentDidUpdate(prevProps) {
		const { item } = this.props
		if (prevProps.item !== item && !!item) {
			if (!!item.get('business_id')) {
				this.handleOnChangeLister(item.get('business_id'))
			}
		}
	}
  
  UNSAFE_componentWillReceiveProps(nextProps) {
	  if (this.props.item !== nextProps.item && !!nextProps.item) {
	    this.props.onSetMarketplaceListing(nextProps.item)
			if (!!nextProps.item.get('business_id')) {
				this.handleOnChangeLister(nextProps.item.get('business_id'))
			}
	  }
  }

	handleOnChangeListerPopover = () => {
		this.props.onOpenManagedBusinessesPopover(this.listerBtn, this.handleOnChangeLister)
	}

	handleOnChangeLister = (businessId) => {
		this.props.onChangeAttr('business_id', businessId)
	}

	handleOnResetLister = () => {
		this.props.onChangeAttr('business_id', null)
	}

	handleOnOpenLocationModal = () => {
		this.props.onOpenLocationModal(this.handleOnChangeLocationObject)
	}

	handleOnChangeLocationObject = (location) => {
		this.handleOnChangeAttr('location_object', location)
	}

	handleOnSubmit = (e) => {
		const { onSubmit, onClose, itemId, history } = this.props
		
		e.preventDefault()

		!!onClose && onClose()

		onSubmit(history, itemId)
	}

	handleOnChangeAttr = (key, value) => {
		this.props.onChangeAttr(key, value)
	}

	setListerBtn = (n) => {
		this.listerBtn = n
	}

	render() {
	  const {
	    item,
	    attrs: propAttrs,
	    isSubmitting,
	    itemId,
	    categories,
			isOwner,
			isError,
			account,
			showForm,
			availableAttrs,
			business,
	  } = this.props

		if (!showForm) {
			return <MarketplaceListingPreview />
		}

		if (isError || !propAttrs || (!isOwner && itemId)) {
			return <ColumnIndicator type='error' />
		} else if (!availableAttrs || (!item && itemId)) {
	    return <ColumnIndicator type='loading' />
	  }

	  const categoriesOptions = [{'title':'',value:''}]
	  if (categories) {
	    for (let i = 0; i < categories.count(); i++) {
	      const c = categories.get(i)
	      categoriesOptions.push({
	        title: c.get('name'),
	        value: c.get('id'),
	      })
	    }
	  }

		// : todo :
		// if editing, show listing as business, show correct lister
		const hasBusinesses = Array.isArray(meBusinesses) && meBusinesses.length > 0

		const attrs = propAttrs.get('attrs')
		const title = attrs.get('title', '')
		const ctaTitleValue = attrs.get('cta_title', '')
		const ctaLinkValue = attrs.get('cta_link', '')
    const locationValue = attrs.get('location', '')
		const locationObject = attrs.get('location_object')
    const price = attrs.get('price', '')
    const descriptionValue = attrs.get('description', '')
    const category = attrs.get('category', '')
		const categoryObj = categories.find((c) => `${c.get('id')}` === `${category}`)
		const condition = attrs.get('condition', '')
		const availableAttrsForCategory = !!category && !!categoryObj ? availableAttrs.get(categoryObj.get('slug')) : null

		const businessAttributesEntered = !!business ? !!ctaTitleValue && !!ctaLinkValue : true
		const submitDisabled = ((!title || !category || !descriptionValue || !businessAttributesEntered) && !itemId) || isSubmitting

	  return (
			<div className={[_s.d, _s.w100PC].join(' ')}>			

				<div className={[_s.d, _s.flexRow, _s.mb10, _s.pb10, _s.pt10].join(' ')}>
					{ !business && <Avatar size={38} account={account} /> }
					{
						!!business &&
						<Image
							src={business.get('logo_thumbnail_url')}
							width={38}
							height={38}
							className={[_s.radiusTiny].join(' ')}
						/>
					}
					<div className={[_s.d, _s.pl10].join(' ')}>
						{ !business && <DisplayName account={account} noUsername /> }
						{ !!business && <Text size='medium'>{business.get('name')}</Text> }
						<div className={[_s.d, _s.flexRow, _s.pt5, _s.aiCenter].join(' ')}>
							<Icon id='globe' size='12px' className={_s.cTertiary} />
							<Text className={_s.ml7} size='small' color='tertiary'>
								Listing to Marketplace
								{!!business ? ' as Business' : ''}
							</Text>
						</div>
					</div>
				</div>

				{
					hasBusinesses &&
					<div className={[_s.d, _s.w100PC, _s.mb15].join(' ')}>
						<Button
							radiusSmall
							color='primary'
							backgroundColor='secondary'
							onClick={this.handleOnChangeListerPopover}
							buttonRef={this.setListerBtn}
							className={[_s.flexRow, _s.aiCenter, _s.jcCenter].join(' ')}
						>
							<Text color='inherit' weight='medium' className={_s.mrAuto}>
								Select a Business
							</Text>
							<Icon id='angle-right' />
						</Button>
					</div>
				}
				{
					!hasBusinesses &&
					<div>
						<Text>
							Starting Jan 1st, 2024, Gab Marketplace will be accepting only listings and products from approved businesses.
						</Text>
						<Button
							isBlock
							radiusSmall
							className={[_s.mt10].join(' ')}
							to='/marketplace/business/join'
						>
							<Text color='inherit' weight='bold' size='large' align='center'>Submit my Business</Text>
						</Button>
					</div>
				}
				{
					hasBusinesses &&
					<>
						<MarketplaceListingMediaUploadBlock isDisabled={isSubmitting} isEditing={itemId} />
						
						<Divider isInvisible />

						<Input
							id='marketplace-listing-title'
							title='Title *'
							maxLength={120}
							value={title}
							onChange={(value) => this.handleOnChangeAttr('title', value)}
							isDisabled={isSubmitting}
							placeholder='Marketplace item title...'
							isRequired
						/>

						<Divider isInvisible />

						<Textarea
							title='Description *'
							value={descriptionValue}
							onChange={(value) => this.handleOnChangeAttr('description', value)}
							placeholder='This marketplace item is about...'
							isDisabled={isSubmitting}
							className={_s.minH150PX}
							maxLength={3000}
							isRequired
						/>

						<Divider isInvisible />

						<Input
							inputType='number'
							id='marketplace-listing-price'
							title='Price (USD) *'
							placeholder='0.00'
							type='number'
							maxLength={8}
							value={price}
							onChange={(value) => this.handleOnChangeAttr('price', value)}
							isDisabled={isSubmitting}
						/>

						<Divider isInvisible />	

						<div className={_s.d}>
							<Text className={[_s.mb10, _s.pb5].join(' ')} size='small' weight='medium'>
								Condition *
							</Text>
							<Select
								value={condition}
								onChange={({target: { value }}) => this.handleOnChangeAttr('condition', value)}
								options={conditionsOptions}
								isDisabled={isSubmitting}
							/>
						</div>

						<Divider isInvisible />	


						<div className={[_s.d].join(' ')}>
							<Text className={_s.mb10} size='small' weight='medium'>
								Category *
							</Text>
							<Select
								value={category}
								onChange={({target: { value }}) => this.handleOnChangeAttr('category', value)}
								options={categoriesOptions}
								isDisabled={isSubmitting}
							/>
						</div>

						{
							!!availableAttrsForCategory && availableAttrsForCategory.map((availableAttr) => {
								const aaKey = availableAttr.get('key')
								const aaType = availableAttr.get('type')
								const aaTitle = availableAttr.get('title')
								const aaSubtitle = availableAttr.get('subtitle')
								const aaOptions = availableAttr.get('options')
								const aaValue = attrs.getIn(['attrs', aaKey])
								const aaId = `marketplace-listing-attr-${category}-${aaKey}`
								// : todo : fix multiple
								const isSelect = ['color', 'year', 'select'].indexOf(aaType) > -1
								const isInput = ['input', 'number'].indexOf(aaType) > -1

								let component

								if (isSelect) {
									let aaActualOptions = 
										['select', 'multiple'].indexOf(aaType) > -1 ? [{title: '',value: ''}].concat(aaOptions.toJS()) :
										aaType === 'color' ? MARKETPLACE_LISTING_COLOR_OPTIONS :
										aaType === 'year' ? MARKETPLACE_LISTING_YEAR_OPTIONS : []

									component = (
										<div className={_s.d}>
											<Text className={_s.mb10} size='small' weight='medium'>
												{aaTitle}
											</Text>
											<Select
												value={aaValue}
												isMultiple={aaType === 'multiple'}
												onChange={({target: { value }}) => this.handleOnChangeAttr(['attrs', aaKey], value)}
												options={aaActualOptions}
												isDisabled={isSubmitting}
											/>
										</div>
									)
								} else if (isInput) {
									component = (
										<Input
											id={aaId}
											title={aaTitle}
											subtitle={aaSubtitle}
											value={aaValue}
											isDisabled={isSubmitting}
											maxLength={256}
											type={aaType}
											// placeholder='This marketplace item is about...'
											onChange={(value) => this.handleOnChangeAttr(['attrs', aaKey], value)}
										/>
									)
								} else if (aaType === 'textarea') {
									component = (
										<Textarea
											id={aaId}
											title={aaTitle}
											subtitle={aaSubtitle}
											value={aaValue}
											isDisabled={isSubmitting}
											className={_s.minH150PX}
											maxLength={3000}
											onChange={(value) => this.handleOnChangeAttr(['attrs', aaKey], value)}
											// placeholder='This marketplace item is about...'
										/>
									)
								} else if (aaType === 'boolean') {
									component = (
										<Switch
											label={aaTitle}
											subtitle={aaSubtitle}
											id={aaId}
											disabled={isSubmitting}
											checked={aaValue}
											onChange={(checked) => this.handleOnChangeAttr(['attrs', aaKey], checked)}
											labelProps={{
												weight: 'medium',
												color: 'primary',
											}}
										/>
									)
								}

								if (!component) return null

								return (
									<>
										<Divider isInvisible />
										{component}
									</>
								)
							})
						}
						
						<Divider isInvisible />

						<div className={[_s.d, _s.mb10, _s.py5].join(' ')}>
							<Text weight='medium' color='primary' tagName='label'>
								Location
							</Text>
						</div>
						<Button
							noClasses
							isDisabled={isSubmitting}
							onClick={this.handleOnOpenLocationModal}
							className={[_s.d, _s.px10, _s.py10, _s.jcCenter, _s.w100PC, _s.minH40PX, _s.bgPrimary, _s.radiusTiny, _s.border1PX, _s.borderColorInput, _s.cursorPointer, _s.outlineNone, _s.outlineBrand_onFocus].join(' ')}
						>
							{
								!!locationObject && isObject(locationObject) &&
								<Text size='large' weight='medium' color='brand'>{locationObject.display_name}</Text>
							}
							{
								!locationObject && <Text size='large' color='tertiary'>Select location</Text>
							}
						</Button>
						

						{/* <Input
							id='marketplace-listing-location'
							title='Location'
							placeholder='City, State'
							maxLength={120}
							value={locationValue}
							onChange={(value) => this.handleOnChangeAttr('location', value)}
							isDisabled={isSubmitting}
						/>
						<Text className={[_s.mt5].join(' ')} size='small' color='tertiary'>
							(Optional) Add a location to help local buyers
						</Text> */}

						{
							!!business &&
							<>
								<Divider isInvisible />

								<Input
									id='marketplace-listing-cta-title'
									title='Call to Action Title *'
									placeholder='Buy Now, Visit our Website, Shop Now, etc.'
									maxLength={120}
									value={ctaTitleValue}
									onChange={(value) => this.handleOnChangeAttr('cta_title', value)}
									isDisabled={isSubmitting}
									isRequired
								/>
								<Text className={[_s.mt5].join(' ')} size='small' color='tertiary'>
									(Business - Required) Direct customers to your listing
								</Text>

								<Divider isInvisible />
								
								<Input
									id='marketplace-listing-cta-link'
									title='Call to Action Link *'
									placeholder='https://example.com/product/1'
									maxLength={280}
									value={ctaLinkValue}
									onChange={(value) => this.handleOnChangeAttr('cta_link', value)}
									isDisabled={isSubmitting}
									isRequired
								/>
							</>
						}

						<Divider isInvisible />

						<div className={[_s.d, _s.borderTop1PX, _s.borderColorSecondary, _s.mt5, _s.py15].join(' ')}>
							<Button
								radiusSmall
								isDisabled={submitDisabled}
								onClick={this.handleOnSubmit}
								className={_s.mt15}
							>
								<Text color='inherit' align='center' size='medium' weight='medium'>
									{!!itemId ? 'Update Marketplace Listing' : 'Create Marketplace Listing'}
								</Text>
							</Button>
						</div>
					</>
				}
			</div>
	  )
	}

}

const mapStateToProps = (state, { params }) => {
  const itemId = isObject(params) ? params.id : null
  const item = state.getIn(['marketplace_listings', `${itemId}`])

	// : todo :
	// if already has item (i.e. is editing)
	// make sure current user is owner the item

	const isOwner = !!item ? item.getIn(['account', 'id']) === me : false
	if (itemId && item && !isOwner) {
		return {
			itemId,
			isError: true,
		}
	}

	const businessListerId = state.getIn(['marketplace_listing_editor', 'attrs', 'business_id'])
	const business = state.getIn(['businesses', 'items', businessListerId])

  return {
    item,
    itemId,
		isOwner,
		business,
		account: state.getIn(['accounts', me]),
    attrs: state.getIn(['marketplace_listing_editor']),
    categories: state.getIn(['marketplace_listing_categories', 'items']),
		availableAttrs: state.getIn(['marketplace_listing_search', 'available_attrs']),
  }
}

const mapDispatchToProps = (dispatch) => ({
  onChangeAttr(key, value) {
		if (key === 'business_id' && !!value && Array.isArray(meBusinesses)) {
			// make sure user owns the business_id
			let exists = meBusinesses.indexOf(`${value}`) > -1
			if (!exists) return false
		}
    dispatch(changeMarketplaceListingAttr(key, value))
  },
  onResetEditor() {
    dispatch(resetEditor())
  },
  onSetMarketplaceListing(item) {
    dispatch(setMarketplaceListing(item))
  },
  onSubmit(routerHistory, itemId) {
		if (itemId) {
			// if editing, show confirmation modal
			dispatch(openModal(MODAL_CONFIRM, {
				title: 'Submit Listing Update',
				message: 'After submitting an update, your listing will need to be approved by our moderation team again if you have changed the title, description or media.',
				confirm: 'Submit',
				onConfirm: () => {
					dispatch(submit(routerHistory, itemId))
					dispatch(closeModal())
				},
			}))
		} else {
			dispatch(submit(routerHistory, itemId))
			dispatch(closeModal())
		}
  },
  onFetchMarketplaceListing(id) {
    dispatch(fetchMarketplaceListingById(id))
  },
  onFetchMarketplaceListingCategories() {
    dispatch(fetchMarketplaceListingCategories())
  },
	onOpenManagedBusinessesPopover(targetRef, onClick) {
		dispatch(openPopover(POPOVER_MANAGED_BUSINESSES, {
			targetRef,
			onClick,
		}))
	},
	onOpenLocationModal(onChange) {
		dispatch(openModal(MODAL_LOCATION, {
			withLocation: true,
			onChange,
		}))
	},
	onFetchManagedBusinesses() {
    dispatch(fetchManagedBusinesses())
  },
})

MarketplaceListingCreate.propTypes = {
  onFetchMarketplaceListing: PropTypes.func,
  onFetchMarketplaceListingCategories: PropTypes.func,
  onResetEditor: PropTypes.func,
  onSetMarketplaceListing: PropTypes.func,
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  onClose: PropTypes.func,
  category: PropTypes.string,
  categories: ImmutablePropTypes.list,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MarketplaceListingCreate))
